/* eslint-disable max-lines */
// Routes is for the applications workflow definitions.
import React from 'react';
import Logo from './src/assets/images/logo.svg';

import { RouteBuilder, base } from '@fingermarkglobal/router';
// Custom views
import { CustomHomeView } from './src/views/home';
import { CustomBeaconView } from './src/views/beacon';
import { CustomReceiptView } from './src/views/receipt';
import { CustomCategoriesView } from './src/views/categories';
import { CustomCategoryView } from './src/views/category';
import { CustomProductComboView } from './src/views/product-combo';
import { CustomCustomerDetailsView } from './src/views/customer-details';
import { CustomAdminView } from './src/views/admin';
import { CustomCartView } from './src/views/cart';

// Custom templates
import { CustomDefaultTemplate } from './src/templates/default';

import { Loading } from '@fingermarkglobal/kfc-styles';

import { Warning } from './src/components/stateless/warning';

import mockSettings from './mock-settings.json';

const LogoComponent = () => <Logo data-test="logo" className="absolute top-0 w-auto h-64 mt-32" />;

const config = {
  ...base,
  home: {
    ...base.home,
    View: CustomHomeView,
    config: {
      ...base.home.config,
      provider: {
        allowedLanguages: ['en', 'fr-CA'],
      },
    },
  },
  beacon: {
    ...base.beacon,
    View: CustomBeaconView,
    config: {
      ...base.beacon.config,
      template: {
        headerEnabled: false,
      },
    },
  },
  coupon: {
    ...base.coupon,
    config: {
      ...base.coupon.config,
      provider: {
        disableModifyUpsellOnCart: true,
      },
    },
  },
  category: {
    ...base.category,
    View: CustomCategoryView,
    config: {
      ...base.category.config,
      provider: {
        ...base.category.config.provider,
      },
    },
  },
  customer: {
    ...base.customer,
    View: CustomCustomerDetailsView,
    config: {
      ...base.customer.config,
    },
  },
  admin: {
    ...base.admin,
    View: CustomAdminView,
    config: {
      ...base.admin.config,
    },
  },
  validate: {
    ...base.validate,
    config: {
      ...base.validate.config,
      provider: {
        image: LogoComponent,
        isLogoEnabled: true,
        showFinancialSummaryTotal: true,
      },
    },
  },
  confirmation: {
    ...base.confirmation,
    config: {
      ...base.confirmation.config,
      provider: {
        image: LogoComponent,
        isLogoEnabled: true,
        customOrderReference: true,
      },
    },
  },
  receipt: {
    ...base.receipt,
    View: CustomReceiptView,
  },
  composed: {
    ...base.composed,
    config: {
      ...base.composed.config,
      provider: {
        showCategoriesHeader: true,
        disableModifyUpsellOnCart: true,
      },
    },
  },
  lock: {
    ...base.lock,
    config: {
      ...base.lock.config,
      template: {
        ...base.lock.config.template,
        timeoutEnabled: false,
      },
    },
  },
  cart: {
    ...base.cart,
    View: CustomCartView,
    config: {
      ...base.cart.config,
    },
  },
  categories: {
    ...base.categories,
    View: CustomCategoriesView,
    config: {
      ...base.categories.config,
    },
  },
  combo: {
    ...base.combo,
    View: CustomProductComboView,
    config: {
      ...base.combo.config,
    },
  },
  loyalty: {
    ...base.loyalty,
    config: {
      ...base.loyalty.config,
    },
  },
  offers: {
    ...base.offers,
    config: {
      ...base.offers.config,
    },
  },
};

const Routes = () => (
  <RouteBuilder
    Template={CustomDefaultTemplate}
    root={{
      ErrorComponent: Warning,
      resolverProps: { Loading, isRetryActive: true },
      overwriteSettings: mockSettings,
    }}
    config={config}
  />
);

export { Routes };
